import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import all_assets from './modules/assets';
import user from './modules/user';
import settings from './modules/settings';
import button from './modules/button';
import module_servers from './modules/servers';
import earnings from './modules/earnings';
import creator from './modules/creator';
import recentEarnings from './modules/recentEarnings';
import cashback from './modules/cashback';
import tags from './modules/tags';
import pagination from './modules/pagination';

export default new Vuex.Store({
    modules: {
        all_assets,
        user,
        settings,
        button,
        module_servers,
        earnings,
        creator,
        recentEarnings,
        cashback,
        tags,
        pagination,
    },
});
